var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[(_vm.isXsMobile || _vm.isMobile)?_c('error-modal',{staticClass:"modal",attrs:{"is-opened":""},on:{"submit":_vm.submit}}):_c('error-desktop',{staticClass:"desktop",on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }